import React, { FC } from "react";

interface AsideArray {
    title: string;
    content: string | Array<string>;
    link?: string;
}
interface AsideType {
    data: AsideArray[];
}

const Aside: FC<AsideType> = ({ data }) => {
    return (
        <aside className="flex flex-col items-start p-7 aside sm:sticky top-24">
            {data.map((x, i) => {
                return (
                    <div key={i}>
                        <h4 className="title mb-4">{x.title}</h4>
                        {x.title === "website" ? (
                            <a className="cursor-pointer" onClick={() => window.open(`https://${x.link}`, "_blank")} rel="noreferrer">
                                <p className="description underline decoration-solid">{x.content}</p>
                            </a>
                        ) : Array.isArray(x.content) ? (
                            x.content.map((eachitem, i) => (
                                <ul key={i} className="p-0">
                                    <li className="description list-none m-0 p-0">{eachitem}</li>
                                </ul>
                            ))
                        ) : (
                            <p className="description">{x.content}</p>
                        )}
                    </div>
                );
            })}
        </aside>
    );
};

export default Aside;
